<template>
  <v-card v-if="course && course.id" elevation="0" class=" ">
    <v-toolbar
        color="#BC0000"
        dark
    >
      <p class="title-toolbar"> {{course.name}}</p>
    </v-toolbar>

    <v-list three-line>
      <template v-if="students && students.length > 0">
        <v-list-item v-for="student in students" :key="student.id" >
          <v-list-item-avatar v-if="student.student.user.image" width="60" height="60">
            <v-img cover :src="student.student.user.image"></v-img>
          </v-list-item-avatar>
          <v-icon size="60" v-else> mdi-account-circle</v-icon>

          <v-list-item-content>
            <p>
              <strong>Nome: </strong>
              <span>{{student.student.user.name}}</span>
            </p>
            <p class="mt-1">
              <strong>E-mail: </strong>
              <span>{{student.student.user.email}}</span>
            </p>
            <p class="mt-1">
              <strong>Número da inscrição: </strong>
              <span>{{student.numberInscription}}</span>
            </p>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-else>
        <h3 class="ml-3 my-3">Não há inscritos neste curso.</h3>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";

export default {
  name: "Students",
  components: {},
  computed: {},

  props: {
    courseGroupId: {type: Number, required: true, default: null},
    courseId: {type: Number, required: true, default: null}
  },

  created() {
  },

  async mounted() {

  },
  data() {
    return {
      students: [],
      outlined: true,
      options: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 11,
        precision: 2,
        max: 10
      },
      course: Object,
      daysOfTheWeekSelected: [],
      active: [
        {name: "Não", value: 'false'},
        {name: "Sim", value: true},
      ],
      periods: [
        {name: "Matutino", value: "0"},
        {name: "Vespertino", value: '1'},
        {name: "Noturno", value: '2'}
      ],
      levels: [
        {name: "Iniciante", value: "0"},
        {name: "Intermediário", value: '1'},
        {name: "Avançado", value: '2'}
      ],
      daysOfTheWeek: [
        {name: "Domingo", value: 0},
        {name: "Segunda-feira", value: 1},
        {name: "Terça-feira", value: 2},
        {name: "Quarta-feira", value: 3},
        {name: "Quinta-feira", value: 4},
        {name: "Sexta-feira", value: 5},
        {name: "Sábado", value: 6}
      ],
      courseForm: false,
      apiService: new ApiService(),
      rules: {
        required: (value) => !!value || "Campo requerido.",
      }
    };
  },

  methods: {
    async getStudents() {
      try {
        await this.getCourse()
        const {content} = await this.apiService.get(`courseGroup/${this.courseGroupId}/students`)
        this.students = content
      } catch (e) {

      }
    },
    async getCourse() {
      try {
        const {content} = await this.apiService.get(`course/${this.courseId}`,)
        this.course = content
      } catch (e) {

      }
    },
  },

  watch: {},
};
</script>

<style lang='scss' scoped>
.title-toolbar {
  font-weight: 500;
  font-size: 18px;
  margin-top: 7px;
}

</style>
